import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  initialValues,
  validationSchema,
} from "../../../componentes/Administrador_ImportarNomina";
import { useFormik } from "formik";
import { Form, Segment, Divider } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { estiloBotones } from "../../../estilos/botones";
import { estiloColores } from "../../../estilos/colores";
import { apiUsuario } from "../../../api/usuario";
import { apiEmpresa } from "../../../api/empresa";
import Swal from "sweetalert2";
import { ENTORNO } from "../../../utils/constantes";
import { setTitulo, getrole } from "../../../utils/variablesLocales";
import HomeIcon from "@mui/icons-material/Home";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Alert from "@mui/material/Alert";
import logoLocalPoint from "../../../imagenes/logoConNombre.png";

const apiempresa = new apiEmpresa();
const apiusuario = new apiUsuario();

export function ImportarNomina() {
  setTitulo("Nómina");

  ////////////////////////////////

  const [empresas, setEmpresa1] =
    useState(
      null
    ); /*esta variable empresas, maneja el estado del item seleccionado en el combo empresas*/

  const [yaCargo, setyaCargo] = useState(false);

  const [Archivo, setArchivo] = useState("");

  ////////////////////////////////

  /*este es como el load de asp.net*/
  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Administrador") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
        ///////////////////////////////////////////////////////

        if (!yaCargo) {
          //obtengo la lista de empresas para luego cargar el combo
          const respuesta = await apiempresa.obtener();
          setyaCargo(true);
          setEmpresa1(respuesta);

          setArchivo(null);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  ////////////////////////////////

  const navigate = useNavigate();

  const navigateToInicio = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/Inicio");
  };

  const parametro = useLocation();

  const formik = useFormik({
    initialValues: initialValues(parametro.state),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (Archivo === null) {
          Swal.fire({
            title: "Error!",
            text: "Archivo. Requerido",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: estiloColores.Gris,
          });
        } else {
          const respuesta = await apiusuario.nominaImportar(
            Archivo,
            formik.values.EmpresaId
          );
          if (respuesta.status === 200) {
            Swal.fire({
              title: "",
              text: "Nómina importada correctamente",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: estiloColores.Azul,
            }).then(function () {
              // navigateToInicio();
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Error al importar nómina",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: estiloColores.Gris,
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  ////////////////////////////////

  var empresaRegistros = [];

  if (empresas) {
    for (let i = 0; i < empresas.length; i++) {
      empresaRegistros.push({
        key: empresas[i]._id,
        text: empresas[i].Nombre,
        value: empresas[i]._id,
      });
    }
  }

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <div className="divPrincipal_ImportarNomina">
        <AppBar style={{ background: "#DC030E" }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={navigateToInicio}
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <HomeIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Importar nómina de conductores
            </Typography>
            <img
              src={logoLocalPoint}
              style={{ marginTop: "1px" }}
              width="75"
              alt="Logo"
            />
          </Toolbar>
        </AppBar>
        <Segment style={estiloSegmento.Administrador}>
          <Form onSubmit={formik.handleSubmit}>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <Form.Field>
              <label>Empresa</label>
              <Form.Dropdown
                name="empresa"
                value={formik.values.EmpresaId}
                onChange={(_, data) =>
                  formik.setFieldValue("EmpresaId", data.value)
                }
                error={formik.errors.EmpresaId}
                fluid
                selection
                options={empresaRegistros}
                placeholder="Selecciona empresa"
              ></Form.Dropdown>
            </Form.Field>
            <Form.Field>
              <label>Archivo (CSV)</label>
              <input
                placeholder="Selecciona archivo"
                type="file"
                onChange={(e) => {
                  setArchivo(e.target.files[0]);
                }}
              />
            </Form.Field>

            <Alert severity="info">
              <b>Formato de archivo CSV:</b> Localidad, Nombre, Apellido, email,
              password, Telefono, ContactosEmergencia, Dominio, Marca, Modelo,
              AAAA, Color, Seguro, Activo
              <br></br>
              <br></br>
              AAAA: Año
              <br></br>
              Activo: true (activo) o false (inactivo)
              <br></br>
              <br></br>
              Debe estar separado por comas y el orden de las columnas debe
              respetarse de manera exacta.
              <br></br>
              Si el conductor existe (clave única: email), actualiza sus datos.
            </Alert>

            <Divider />
            <Form.Group>
              <Form.Button
                type="submit"
                loading={formik.isSubmitting}
                name="Importar"
                style={estiloBotones.GuardarCambios}
              >
                Importar
              </Form.Button>
            </Form.Group>
          </Form>
        </Segment>
      </div>
    </div>
  );
}
